import SmartSelectElement from 'assets/js/editor/smart-select/models/smart-select-element';
import SmartSelectGroup from 'assets/js/editor/smart-select/models/smart-select-group';
import {
  distributeHorizontally,
  distributeVertically,
  tidy
} from 'assets/js/editor/smart-select/smart-select.service';

module.exports = _.extend({
  initialize: function () {
    const tool = INKIVE.Tool.getInstance();

    this.editor = tool.editor;
    this.canvas = this.editor.canvas;
    this.svgroot = $('#svgroot').get(0);
  },

  horizontal: function ({ selectedElements }) {
    const smartSelectedElements = selectedElements.map((element) => new SmartSelectElement(element, element.getBBox()));
    const smartSelectGroup = new SmartSelectGroup(smartSelectedElements);

    distributeHorizontally(smartSelectGroup).forEach(({ element, newCoordinator }) => {
      this._setPosition(element, newCoordinator);
    });

    this.trigger();
  },

  vertical: function ({ selectedElements }) {
    const smartSelectedElements = selectedElements.map((element) => new SmartSelectElement(element, element.getBBox()));
    const smartSelectGroup = new SmartSelectGroup(smartSelectedElements);

    distributeVertically(smartSelectGroup).forEach(({ element, newCoordinator }) => {
      this._setPosition(element, newCoordinator);
    });

    this.trigger();
  },

  tidy: function ({ selectedElements }) {
    const smartSelectedElements = selectedElements.map((element) => new SmartSelectElement(element, element.getBBox()));
    const smartSelectGroup = new SmartSelectGroup(smartSelectedElements);
    const changedElements = tidy(smartSelectGroup);

    if (changedElements.length > 0) {
      changedElements.forEach(({ element, newCoordinator }) => {
        this._setPosition(element, newCoordinator);
      });
      this.trigger();
    }
  },

  _setPosition: function (elem, coords) {
    const xform = this.svgroot.createSVGTransform();
    const tlist = svgedit.transformlist.getTransformList(elem.getDomElement());

    const currentCoordinator = elem.getCoordinator();

    xform.setTranslate(coords.left - currentCoordinator.left, coords.top - currentCoordinator.top);
    tlist.appendItem(xform);

    svgedit.recalculate.recalculateDimensions(elem.getDomElement());
    this.canvas.selectorManager.requestSelector(elem.getDomElement()).resize();
  }

}, Backbone.Events);
